import {
  ROOT,
  GET_LIST_SERVICE,
  SORT_LIST_SERVICE,
  UPDATE_STATUS_SERVICE,
  DELETE_SERVICE,
  DETAIL_SERVICE,
  UPLOAD_IMAGE_RESOURCE,
  DELETE_IMAGE_RESOURCE,
  UPDATE_SERVICE,
  CREATE_SERVICE,
  CHECK_SERVICE_CODE,
  CHECK_SPECIAL_DAYS_PRICE,
  DELETE_SERVICE_LIST,
  UPDATE_STATUS_SERVICE_ALL
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

//#region list of rooms
function get() {
  return fetch(ROOT + GET_LIST_SERVICE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function sortService( body ) {
  return fetch(ROOT + SORT_LIST_SERVICE, requestOptions.post( body ))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateStatus( id ) {
  return fetch(ROOT + UPDATE_STATUS_SERVICE + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateStatusAll( body ) {
  return fetch(ROOT + UPDATE_STATUS_SERVICE_ALL, requestOptions.post(body))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function deleteService( id ) {
  return fetch(ROOT + DELETE_SERVICE + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function deleteServiceList( body ) {
  return fetch(ROOT + DELETE_SERVICE_LIST, requestOptions.post(body))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getDetailService( id ) {
  return fetch(ROOT + DETAIL_SERVICE + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function uploadImage(data) {
  let currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  let authHeader = currentUser.token ? { Authorization: "Token " + currentUser.token } : {};
  return fetch(ROOT + UPLOAD_IMAGE_RESOURCE, {
    method: "POST",
    body: data,
    headers: {
      Authorization: authHeader.Authorization
    }
  })
    .then(handleResponse)
    .then(data => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      return data;
    });
}

function removeImage(id) {
  return fetch(ROOT + DELETE_IMAGE_RESOURCE + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      return data;
    });
}

function updateService( body ) {
  return fetch(ROOT + UPDATE_SERVICE, requestOptions.post( body ))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function createService( body ) {
  return fetch(ROOT + CREATE_SERVICE, requestOptions.post( body ))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function checkServiceCode( code ) {
  return fetch(ROOT + CHECK_SERVICE_CODE + `/${code}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function checkSpecialDaysPrice( body ) {
  return fetch(ROOT + CHECK_SPECIAL_DAYS_PRICE, requestOptions.post( body ))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#endregion
export const servicePackageService = {
  get,
  sortService,
  updateStatus,
  deleteService,
  getDetailService,
  uploadImage,
  removeImage,
  updateService,
  createService,
  checkServiceCode,
  checkSpecialDaysPrice,
  deleteServiceList,
  updateStatusAll
};
